import { Box, Text } from '@factorialco/deprecated-design-system'
import { F0Icon } from '@factorialco/f0-react'
import AlertCircle from '@factorialco/f0-react/icons/app/AlertCircle'

import { warningLabel } from './index.vanilla.css'

interface WarningLabelProps {
  label: string
}

export const WarningLabel = ({ label }: WarningLabelProps) => (
  <Box flexDirection="row" gap="s2" alignItems="center" justifyContent="flexEnd">
    <Text.Normal color="tangerine1000" size="100">
      <F0Icon icon={AlertCircle} type="warning" />
    </Text.Normal>
    <Text.Normal size="100" className={warningLabel}>
      {label}
    </Text.Normal>
  </Box>
)
